import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M11.2 1C13.79 1 16 3.014 16 6.444 16 9.881 10.565 15 8 15c-2.565 0-8-5.119-8-8.556C0 3.014 2.21 1 4.8 1c1.362 0 2.166.35 3.2 1.258C9.034 1.35 9.838 1 11.2 1z',
    ],
    24: [
        'M7.556 3C5.333 3 2 4.688 2 9.75 2 14.813 9.778 21 12 21c2.222 0 10-6.188 10-11.25C22 4.687 18.667 3 16.444 3 14.222 3 13.111 4.125 12 5.25 10.889 4.125 9.778 3 7.556 3z',
    ],
};
const IconHeartFilled = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconHeartFilled.displayName = 'IconHeartFilled';

export { IconHeartFilled };
//# sourceMappingURL=IconHeartFilled.js.map
